import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  STATE_IDLE,
  STATE_SUCCEEDED,
  STATE_FAILED,
  STATE_LOADING
} from '../../constants'
import { list } from '../../api/service'

const initialState = {
  services: [],
  totalCount: 0,
  pageNumber: 1,
  pageSize: 50,
  q: '',
  status: STATE_IDLE,
  error: null,
  initialServicesSearchState: {
    fetched: false,
    services: [],
    totalCount: 0,
    pageNumber: 1,
    pageSize: 12,
    q: ''
  }
}

export const listServicesAsync = createAsyncThunk(
  'service/list',
  async ({ pageSize, pageNumber, q }) => {
    const listResult = await list({
      pageSize,
      pageNumber,
      q
    })
    return listResult.data
  }
)

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    addService: (state, action) => {
      state.services.unshift(action.payload)
    },
    updateService: (state, action) => {
      state.services = state.services.map((s) => {
        if (s.id === action.payload.id) {
          return action.payload
        } else {
          return s
        }
      })
    },
    useInitialServicesSearchState: (state) => {
      state.services = state.initialServicesSearchState.services
      state.totalCount = state.initialServicesSearchState.totalCount
      state.pageNumber = state.initialServicesSearchState.pageNumber
      state.pageSize = state.initialServicesSearchState.pageSize
      state.q = state.initialServicesSearchState.q
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(listServicesAsync.pending, (state) => {
        state.status = STATE_LOADING
      })
      .addCase(listServicesAsync.fulfilled, (state, action) => {
        state.status = STATE_SUCCEEDED
        state.services = action.payload.services
        state.totalCount = action.payload.totalCount
        state.pageNumber = action.payload.pageNumber
        state.pageSize = action.payload.pageSize
        state.q = action.payload.q
        if (
          !state.initialServicesSearchState.fetched ||
          (state.pageNumber !== state.initialServicesSearchState.pageNumber &&
            !state.q)
        ) {
          state.initialServicesSearchState = {
            fetched: true,
            services: action.payload.services,
            totalCount: action.payload.totalCount,
            pageNumber: action.payload.pageNumber,
            pageSize: action.payload.pageSize,
            q: action.payload.q
          }
        }
      })
      .addCase(listServicesAsync.rejected, (state, action) => {
        state.status = STATE_FAILED
        console.error(action.error)
        state.error = {
          message: action.error
        }
      })
  }
})

export default serviceSlice.reducer
export const { addService, updateService, useInitialServicesSearchState } =
  serviceSlice.actions
